<div *ngIf="layoutHelper.sideNavToggleAction$ | async as toggleStatus" id="app-breadcrumb">
  <ng-container *ngIf="locale$ | async as locale">
    <ng-container *ngIf="{ hasPerspectives: hasPerspectives$ | async } as perspectiveState">
  <div class="breadcrumb-shell gap-3 border-b border-[#cccccc] bg-white px-4 py-3">
        <div class="breadcrumb-header flex w-full items-start gap-3">
          <div class="breadcrumb-main flex min-w-0 flex-1 flex-wrap items-start gap-3 md:gap-4">
            <div id="title-section" class="breadcrumb-title flex min-w-0 items-center gap-3">
            <ng-container *ngIf="pageTitle$ | async as pageTitle">
              <h2 class="truncate text-xl font-semibold text-slate-900 md:text-2xl">{{pageTitle | translate: locale | async}}</h2>
            </ng-container>
            <sd-filter-breadcrumbs class="hidden" [filterModel]="filterModel$"></sd-filter-breadcrumbs>
            </div>
            <div class="breadcrumb-perspective-header flex flex-wrap items-center gap-2" *ngIf="perspectiveState.hasPerspectives">
              <layout-perspective-selector></layout-perspective-selector>
            </div>
          </div>
          <div class="breadcrumb-help flex shrink-0 items-center justify-end" *ngIf="showBreadcrumbMenu">
            <ng-container *ngTemplateOutlet="breadcrumbHelpMenu; context: { locale: locale }"></ng-container>
          </div>
        </div>

        <ng-container *ngIf="showBreadcrumbOptions$ | async">
          <div id="breadcrumb-controls">
            <sd-metric-selector *ngIf="showMetricSelector"></sd-metric-selector>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #breadcrumbHelpMenu let-locale="locale">
  <div id="help-button" class="flex items-center justify-end">
    <button
      mat-button
      [matMenuTriggerFor]="printingOptions"
      class="help-button-trigger inline-flex items-center justify-center rounded-full p-0 leading-none text-[var(--brand-primary)] transition-colors duration-150 hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
      aria-label="Open breadcrumb options"
    >
      <i class="help-button-icon fa fa-ellipsis-v fa-primary text-xl"></i>
    </button>
    <mat-menu #printingOptions="matMenu">
      <button
        mat-menu-item
        *ngIf="helpAvailable"
        (click)="openHelp('StickyFiltersHelp', 'General', locale)"
      >
        {{'Help' | translate: locale | async}}
      </button>
      <button mat-menu-item *ngIf="pdfAvailable" (click)="onClickPDF()">PDF</button>
    </mat-menu>
  </div>
</ng-template>
